import React from "react";
import ListTemplate from "components/ListTemplate";
import Filters from "./Filters";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { AppointmentPhase, Status } from "components";
import SmallDetails from "components/SmallDetails/SmallDetails";
import { useLoaderData } from "react-router";

export const ProductionListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductionListFrontModel>();

  return <ListTemplate
    title={site.currentEnvironment.production.plural}
    filterSet="production_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Production.Paginated}
    getId={item => item.productionId}
    layout={{
      type: "table",
      columns: [{
        key: "date",
        header: RESX.DateTime.lblDate,
        render: item => <SmallDetails
          label={item.startDateWritten}
          subLabel={item.endDateWritten}
        />,
        size: "auto"
      }, {
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <a href={routes.production_Detail(item.productionId).absolute}>{item.name}</a>,
        size: "1.5fr"
      }, {
        key: "status",
        header: RESX.Status.resxStatus,
        render: item => <Status status={item.status} />,
        hidden: site.currentEnvironment.statuses.production.length <= 1,
        size: "1fr"
      }, {
        key: "artist",
        header: site.currentEnvironment.functionGroups.artist.singular,
        render: item => item.artists.map(a => <div key={a}>{a}</div>),
        size: "1.5fr"
      }, {
        key: "shows",
        header: site.currentEnvironment.show.plural,
        className: "s1_cell_financialamount",
        render: item => item.showCount.map(show => <div
          key={show.phase}
          className="flex gap-small justify-end"
        >
          {show.count}
          <AppointmentPhase value={show.phase} displayLabel={false} />
        </div>),
        size: "auto"
      }]
    }}
    filters={<Filters initialStatuses={viewModel.statuses} />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
    options={{
      exportOptions: {
        canExportList: site.permissions.production.canExportList,
        exportOptionsApi: window.CoreApi.Production.ExportOptionsForList
      }
    }}
  />;
};